import React, { useEffect } from "react";
import BadgeRequirementsTable from "./components/badgesTable";
import { fetchCustomPoints } from "../../store/reducers/badgesDetails";
import { useDispatch, useSelector } from "react-redux";
import BadgesDetailsCards from "./components/badgesCards";
import { Box, useMediaQuery, useTheme, CircularProgress } from "@mui/material";

const columns = [
  { id: "badgeImage", label: "Badges" },
  { id: "badgeName", label: "Level" },
  { id: "range", label: "Points Range" },
  { id: "requirements", label: "Requirements" },
];

const Badges = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const organizationId = localStorage.getItem("organisation_id");
  const { customPoints, loading } = useSelector(
    (state) => state.badgesDetails
  );

  useEffect(() => {
    if (organizationId) {
      dispatch(fetchCustomPoints(+organizationId));
    }
  }, [organizationId, dispatch]);

  let rows = [
    {
      badgeName: "Default",
      range: {
        minPoints: customPoints?.no_badge_min || 0,
        maxPoints: customPoints?.no_badge_max || 2,
      },
      requirements: "No requirements",
    },
    {
      badgeName: "Bronze",
      range: {
        minPoints: customPoints?.bronze_min || 3,
        maxPoints: customPoints?.bronze_max || 29,
      },
      requirements: `Max points for reading per day ${
        customPoints?.bronze_reading_max || 4
      } points. Minimum 1 Micro Training/${
        customPoints?.bronze_min_for_mt || 6
      } mo.`,
    },
    {
      badgeName: "Silver",
      range: {
        minPoints: customPoints?.silver_min || 30,
        maxPoints: customPoints?.silver_max || 49,
      },
      requirements: `Max points for reading per day ${
        customPoints?.silver_reading_max || 4
      } points. Minimum 1 Micro Training/${
        customPoints?.silver_min_for_mt || 6
      } mo.`,
    },
    {
      badgeName: "Gold",
      range: {
        minPoints: customPoints?.gold_min || 50,
        maxPoints:
          (!customPoints?.is_platinum && !customPoints?.is_diamond) 
            ? "Max" 
            : customPoints?.gold_max || 99,
      },
      requirements: `Max points for reading per day ${
        customPoints?.gold_reading_max || 2
      } points. Minimum 1 Micro Training/${
        customPoints?.gold_min_for_mt || 4
      } mo.`,
    },
  ];

  if (customPoints?.is_platinum) {
    rows.push({
      badgeName: "Platinum",
      range: {
        minPoints: customPoints?.platinum_min || 100,
        maxPoints:
          (!customPoints?.is_diamond) 
            ? "Max" 
            : customPoints?.platinum_max || 149,
      },
      requirements: `Max points for reading per day ${
        customPoints?.platinum_reading_max || 2
      } points. Minimum 1 Micro Training/${
        customPoints?.platinum_min_for_mt || 3
      } mo.`,
    });
  }

  // ✅ Conditionally add Diamond
  if (customPoints?.is_diamond) {
    rows.push({
      badgeName: "Diamond",
      range: {
        minPoints: customPoints?.diamond_min || 150,
        maxPoints: customPoints?.diamond_max || "Max",
      },
      requirements: `Max points for reading per day ${
        customPoints?.diamond_reading_max || 2
      } points. Minimum 1 Micro Training/${
        customPoints?.diamond_min_for_mt || 2
      } mo.`,
    });
  }

  return (
    <div
      style={{ marginTop: "1rem", paddingBottom: `${isMobile ? "1rem" : ""}` }}
    >
      <div
        style={{
          padding: isMobile ? "0" : "2rem",
          backgroundColor: isMobile ? "transparent" : "#FFF0F1",
          borderRadius: isMobile ? "0" : "16px",
          minHeight: isMobile ? "" : "90vh",
        }}
      >
        <h3
          style={{
            fontWeight: "600",
            color: "#2B2B2B",
            marginBottom: isMobile ? "1rem" : "2rem",
            fontSize: isMobile ? "18px" : "24px",
          }}
        >
          Badge Requirements
        </h3>

        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", my: 4 }}>
            <CircularProgress />
          </Box>
        ) : (
          <>
            {!isMobile && (
              <BadgeRequirementsTable
                loading={loading}
                rows={rows}
                columns={columns}
                table_title={"Badge Requirements"}
              />
            )}

            {isMobile && (
              <Box
                sx={{
                  display: "grid",
                  gap: 1,
                  gridTemplateColumns: "1fr",
                }}
              >
                {rows.map((row, idx) => (
                  <BadgesDetailsCards
                    key={idx}
                    data={{
                      badgeName: row.badgeName,
                      range: `${row.range.minPoints} - ${row.range.maxPoints}`,
                      requirements: row.requirements,
                    }}
                    index={idx}
                  />
                ))}
              </Box>
            )}
          </>
        )}

        <p
          style={{
            color: "#F44336",
            fontWeight: "600",
            marginTop: `${isMobile ? "1rem" : "3rem"}`,
            fontSize: `${isMobile ? "16px" : "24px"}`,
            textAlign: "center",
          }}
        >
          Important Note:{" "}
          <span
            style={{
              color: "#444",
              fontWeight: "500",
              fontSize: `${isMobile ? "16px" : "24px"}`,
            }}
          >
            Each badge will be evaluated every{" "}
            {customPoints?.evaluation_time || "28"} days.
          </span>
        </p>
      </div>
    </div>
  );
};

export default Badges;
